import e from "../../../node_modules/jwt-decode/build/jwt-decode.esm.js";
var o = function o(_o) {
  try {
    var r;
    return (null === (r = e(_o || "")) || void 0 === r ? void 0 : r.exp) > Math.floor(Date.now() / 1e3);
  } catch (e) {}
  return !1;
};
export { o as isTokenValid };